import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { PAGE_TWO_STYLES } from "../constants";
import { PageTwoFormData } from "../models";

const SectionField = ({
  label,
  name,
  options = [],
  height = "44px",
  control,
  t,
}: {
  label: string;
  name: keyof PageTwoFormData;
  options?: any[];
  height?: string;
  control: any;
  t: any;
}) => (
  <Grid md={3} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <ByzMuiTypography
        sx={{
          ...PAGE_TWO_STYLES.label,
          height,
        }}
      >
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ByzMuiSelect
            {...field}
            renderInput={(params: any) => <ByzMuiTextField {...params} />}
            options={options}
            label={t("open-process-menu.select")}
            placeholder={t("open-process-menu.select")}
            sx={PAGE_TWO_STYLES.select}
          />
        )}
      />
    </Grid>
  </Grid>
);

const PatientNutritionInfo: React.FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageTwoFormData>();

  return (
    <>
      <Grid sx={PAGE_TWO_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingRight="20px" paddingTop="5px">
          {t("adult-patient-assessment.patient-info")}
        </ByzMuiTypography>
      </Grid>
      
      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap">
        <SectionField label="adult-patient-assessment.nutrition" name="preAdmissionDiet" control={control} t={t} />
        <SectionField label="adult-patient-assessment.food-allergies" name="foodAllergies" control={control} t={t} />
        <SectionField label="adult-patient-assessment.appetite-change" name="appetitChange" control={control} t={t} />
        <SectionField label="adult-patient-assessment.food-intolerance" name="foodIntolerance" control={control} t={t} />
        <SectionField label="adult-patient-assessment.chewing-swallowing-difficulty" name="chewingSwallowingDifficulty" control={control} t={t} />
        <SectionField label="adult-patient-assessment.weight-loss-last-month" name="weightLossLastMonth" control={control} t={t} />
        <SectionField label="adult-patient-assessment.weight-loss-amount" name="howMuchWeightLoss" control={control} t={t} />
        <SectionField label="adult-patient-assessment.is-isolated" name="isIsolated" control={control} t={t} />
      </Stack>

      <Box sx={{ my: 4 }}>
        <Grid sx={PAGE_TWO_STYLES.sectionTitle}>
          <ByzMuiTypography isTitle paddingRight="20px" paddingTop="5px">
             {t("adult-patient-assessment.transfusion-history")}
          </ByzMuiTypography>
        </Grid>
        <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap">
          <SectionField 
            label="adult-patient-assessment.previous-transfusion-reaction" 
            name="previousTransfusionReaction" 
            control={control}
            t={t}
          />
        </Stack>
      </Box>
    </>
  );
};

export default PatientNutritionInfo;
